# frozen_string_literal: true

module Engine
  module Game
    module G18JPT
    end
  end
end
